import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

function normalizarImpressoraComprovanteLocal(data = {}) {
  return {
    modo: data.modo === 'local' ? 'local' : 'remote',
    device: data.device || '',
    tamanho_bobina_mm: Number(data.tamanho_bobina_mm || 70),
    fonte_tamanho: Number(data.fonte_tamanho || 13)
  };
}

export default new Vuex.Store({
  state: {
    dataUser: {
      token: '',
      empresa: '',
      nome_usuario: '',
      id_funcao: '0',
      nome_fantasia: '',
      entregadores: null,
      site: '',
      acessos: null
    },

    x_auth: '',
    req_estoque: false,
    id_catalogo: null,
    statusEmpresa: {
      token: null,
      agendamento: '1',
      ativo: '1',
      status: '1',
      aberto: '0',
      entregas: [],
      titulo_pausa: null
    },

    is_block: false,
    is_mobile: false,
    is_comanda: false,
    msgServer: '',
    load: false,
    session: '',
    canPlay: false,
    printLocal: false,
    printServer: false,
    isReady: false,
    isReadOnly: false,
    isTerminal: false,
    informes: [],
    informesCarregados: false,
    alertas: [],
    ocorrencias: [],
    printers: [],
    novidades: 0,
    chats: [],
    bell: {
      status: false,
      orders: 0
    },

    empresas: [],
    modalOcorrencia: false,
    modalOflline: false,
    pilotoAutomatico: false,
    modalFilaPrint: false,
    modalChat: false,
    printsError: 0,
    orderPrints: [],
    impressoesKanban: [],
    impressoesRemotas: [],
    impressora: {},
    impressoraComprovanteLocal: normalizarImpressoraComprovanteLocal(),
    configImpressao: {
      migrado_legado: 0,
      print_automatico: 0,
      mobile_print: 0,
      id_impressora_comprovante: null,
      impressora_comprovante_device: '',
      impressora_comprovante_bobina: 80,
      impressora_comprovante_fonte: 9
    },
    integracoes: [],

    logsIfood: false,
    chatIfood: false,
    ifoodAtivo: false,
    statusIfood: false,

    // comanda
    produtos: [],
    colaboradores: [],
    categorias: [],
    catalogos: [],
    termosRapidos: [],
    pagamentos: [],
    pagamentos_empresa: [],
    zonasEntrega: [],

    pdv: {
      qtd_mesas: 12,
      qtd_comandas: 12,
      valor_frete: 0,
      estacionamento: 0,
      cover: 0,
      taxa_servico: 0,
      unidade_medida: 1,
      senha_pdv: '',
      json_config: {}
    },

    version: { gestor_web: null, app_electron: null, electronV: 0 },
    configsLocal: {
      mostrar_comanda: '0'
    }
  },

  mutations: {
    setDataUser: (state, data) => {
      const dados = data.dados;
      const master = dados.master >= '1';
      const id_catalogo = data.acessos ? (data.acessos.id_catalogo || null) : null;
      state.dataUser = {
        ...dados,
        master,
        admin: (dados.id_funcao <= '1'),
        isGarcom: (dados.id_funcao === '3'),
        entregadores: data.entregadores && data.entregadores.length ? data.entregadores : null,
        empresa: data.dados.token,
        integracoes: (data.integracoes || []).map(i => i.plataforma),
        acessos: {
          menus: data.acessos ? (data.acessos.menus || ['1','2','3','4','5']) : ['1','2','3','4','5'],
          restringir_vendas: data.acessos ? (data.acessos.restringir_vendas || '0') : '0',
          bloquear_finalizar: data.acessos ? (data.acessos.bloquear_finalizar || '0') : '0',
        }
      };

      if (dados.is_comanda === '1' || localStorage.getItem('isComanda') === '1') {
        state.is_comanda = true;
      }

      state.id_catalogo = id_catalogo || localStorage.getItem('catalogo') || null;
    },

    setBell(state, data) {
      state.bell = { status: !!data, orders: (data || 0) };
      document.title = (data > 0 ? `LeCard Gestor (${data}) ` : 'LeCard Gestor');
    },

    setReadOnly(state, data) {
      state.isReadOnly = data;
      document.title = (data > 1 ? `LeCard PDV (${data}) ` : '') + "LeCard PDV";
    },

    setConfigs: (state, data) => {
      // state.pdv = data;
      // 17-10-2025 => Ajuste na taxa_servico por causa da POS, remover depois que arrumar
      state.pdv = { ...data, taxa_servico: (data.taxa_servico === '1') ? '10' : data.taxa_servico };
    },

    setZonas: (state, data) => {
      state.zonasEntrega = data;
    },

    setProdutos: (state, data)  => {
      state.catalogos = data.catalogos || [];

      if (typeof String.prototype.normalize === 'function') {
        let produtos = data.produtos;
        let categorias = data.categorias;

        if (state.id_catalogo && state.catalogos.length) {
          let catalogo = state.catalogos.find(c => c.id_catalogo === state.id_catalogo)

          if (catalogo) {
            state.req_estoque = catalogo.req_estoque === '1';
            produtos = catalogo.produtos || [];

          } else {
            state.id_catalogo = null;
          }
        }

        categorias = produtos.reduce((acc, produto) => {
          if (!acc.some(p => p.id_categoria === produto.id_categoria)) {
            const cat = categorias.find(c => c.id_categoria === produto.id_categoria)
            if (cat) { acc.push(cat) }
          }
          return acc;
        }, []);

        state.categorias = categorias.length ? categorias.sort((a, b) => {
          return parseInt(a.ordem) - parseInt(b.ordem);
        }) : [];

        state.produtos = produtos.map(p => {
          return {
            ...p,
            estoque: null,
            quantidade: 0,
            divisoes: p.divisoes ? p.divisoes.map(d => { return { ...d, normalized: (d.nome_produto.normalize('NFD').replace(/[\u0300-\u036f]/g, "") + ` ${d.ref_produto}`).toLowerCase() } }) : null,
            normalized: (`${p.nome_produto} ${p.nome_categoria}`.normalize('NFD').replace(/[\u0300-\u036f]/g, "") + ` ${p.ref_produto}`).toLowerCase()
          }
        });

      } else {
        state.categorias = data.categorias;
        state.produtos = data.produtos;
        state.catalogos = data.catalogos;
      }

      state.produtos.push({
        "id_produto": "000",
        "id_tabela_preco": "REF001",
        "nome_produto": "Diversos",
        "ref_produto": "001",
        "nome_categoria": "PDV",
        "valor_custo": "0",
        "valor": "0.00",
        "id_medida": "1",
        "tipo_venda": "0",
        "adicionais": [],
        "divisoes": [],
        "normalized": "001 diversos"
      });

      state.produtos.push({
        "id_produto": "REF002",
        "id_tabela_preco": "REF002",
        "nome_produto": "Taxa de Entrega",
        "ref_produto": "002",
        "nome_categoria": "PDV",
        "valor_custo": "0",
        "valor": state.pdv.valor_frete,
        "id_medida": "1",
        "tipo_venda": "0",
        "adicionais": [],
        "divisoes": [],
        "normalized": "002 taxa de entrega frete"
      });
    },

    setTermos: (state, data)  => {
      state.termosRapidos = data;
    },

    setPagamentos: (state, data)  => {
      if (data) {
        state.pagamentos = data.pagamentos || [];
        state.pagamentos_empresa = data.pagamentos_empresa || [];
      }
    },

    addOcorrencia(state, data) {
      const hj = new Date();
      const day = String(hj.getDate()).padStart(2,'0');
      const month = String(hj.getMonth() + 1).padStart(2,'0');
      const hours = String(hj.getHours()).padStart(2,'0');
      const minutes = String(hj.getMinutes()).padStart(2,'0');
      data.data_informe = `${day}/${month}/${hj.getFullYear()} - ${hours}:${minutes}`;
      data.id_informe = data.id_informe || hj.getTime();
      const index = state.ocorrencias.findIndex(a => a.id_informe === data.id_informe);

      if (index !== -1) {
        state.ocorrencias.splice(index, 1);

      } else {
        state.novidades++;
      }

      state.ocorrencias.unshift(data);
      localStorage.setItem('ocorrencias', JSON.stringify(state.ocorrencias));

      setTimeout(() => {
        state.modalOcorrencia = true;
      }, 2000);
    },

    setAlertas(state, alertas) {
      state.alertas = alertas;
    },

    removeAlerta(state, id) {
      state.alertas = state.alertas.filter(alerta => alerta.id !== id);
    },

    addOrderPrints(state, id_pedido) {
      if (!state.orderPrints.includes(id_pedido)) {
        state.orderPrints.push(id_pedido);
      }
    },

    removerOrderPrint(state, id) {
      state.orderPrints = state.orderPrints.filter(pid => pid !== id);
    },

    acompanharImpressaoRemota(state, ids) {
      (Array.isArray(ids) ? ids : [ids]).map(Number).forEach(id => {
        if (Number.isSafeInteger(id) && id > 0 && !state.impressoesRemotas.includes(id)) {
          state.impressoesRemotas.push(id);
        }
      });
    },

    finalizarAcompanhamentoRemoto(state, ids) {
      state.impressoesRemotas = state.impressoesRemotas.filter(id => !ids.includes(id));
    },

    aguardarImpressaoKanban(state, id_pedido) {
      if (id_pedido && !state.impressoesKanban.some(p => String(p.id_pedido) === String(id_pedido))) {
        state.impressoesKanban.push({ id_pedido, confirmado: false });
      }
    },

    confirmarImpressaoKanban(state, id_pedido) {
      const pedido = state.impressoesKanban.find(p => String(p.id_pedido) === String(id_pedido));
      if (pedido) pedido.confirmado = true;
    },

    finalizarImpressaoKanban(state, id_pedido) {
      state.impressoesKanban = state.impressoesKanban.filter(p => String(p.id_pedido) !== String(id_pedido));
    },

    setImpressoraComprovanteLocal(state, data) {
      state.impressoraComprovanteLocal = normalizarImpressoraComprovanteLocal(data);
    },

    setConfigImpressao(state, data) {
      state.configImpressao = {
        migrado_legado: Number(data.migrado_legado || 0),
        print_automatico: Number(data.print_automatico || 0),
        mobile_print: Number(data.mobile_print || 0),
        id_impressora_comprovante: data.id_impressora_comprovante ? Number(data.id_impressora_comprovante) : null,
        impressora_comprovante_device: data.impressora_comprovante_device || '',
        impressora_comprovante_bobina: Number(data.impressora_comprovante_bobina || 80),
        impressora_comprovante_fonte: Number(data.impressora_comprovante_fonte || 9)
      };
    }
  },

  actions: {},

  modules: {
  }
})
